import { Link, useNavigate, useParams } from "react-router-dom";
import AuthLayout from "../../../components/innerComponents/AuthLayout";
import * as Yup from 'yup'
import { useFormik } from "formik";
import Input from "components/innerComponents/Input";
import LoadingIndicator from "components/LoadingIndicator";
import useAuth from "hook/useAuth";
import { useMutation } from "react-query";
import { authAtom } from "hook/state/auth";
import { useSetRecoilState } from "recoil";
import { notify } from "components/Alerts";
import { DASHBOARD } from "navigation/routes";
import { scrollToErrors } from "utils/functions";
import YupPassword from 'yup-password';
import { baseURL } from "hook/useAxios";
YupPassword(Yup)

const SignupPage = () => {
    const navigate = useNavigate()
    const params = useParams()
    const setAuth = useSetRecoilState(authAtom);
    const { registerUser } = useAuth()
    const { mutate, isLoading } = useMutation(registerUser, {
        onSuccess: data => {
            setAuth(data.data);
            navigate(`/users/${DASHBOARD}`, { replace: true })
        },
        onError: error => {
            notify(error, { type: 'error' })
        }
    })

    const loginHandler = (name) => {
        let url = `${baseURL}/user/auth/social/${name}/login`;
        window.open(url,
            'Authenticate Account',
            'menubar=0, location=0,toolbar=0, titlebar=0, status=0, scrollbars=1'
        )
    }
    const formik = useFormik({
        validationSchema,
        enableReinitialize: true,
        initialValues: {
            first_name: '',
            last_name: '',
            email: '',
            referrer: params?.referrer ?? '',
        },
        onSubmit: (values) => {
            setAuth(null)
            const credentials = {
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email,
                referrer: values.referrer,
                callbackUrl: `${window.location.origin}/reset-password`
            }
            mutate(credentials)
        },
    })

    return (
        <AuthLayout>
            <div className="card shadow-lg border-0 rounded-lg mt-5 mb-5">
                <div className="card-header bg-red text-white"><h3
                    className="text-center font-weight-light my-4">Register</h3></div>
                <div className="card-body">
                    <div className="text-center flex flex-column gap-2 social-btn">
                        <a onClick={() => loginHandler('facebook')} className="btn btn-info2 btn-block"><i className="fa-brands fa-facebook"></i> Sign in with <b>Facebook</b></a>
                        <a onClick={() => loginHandler('twitter')} className="btn btn-info btn-block"><i className="fa-brands fa-twitter"></i> Sign in with <b>Twitter</b></a>
                        <a onClick={() => loginHandler('google')} className="btn btn-danger btn-block"><i className="fa-brands fa-google"></i> Sign in with <b>Google</b></a>
                    </div>
                    <div className="or-seperator"><i>or</i></div>
                    <form onSubmit={formik.handleSubmit}>
                        <Input
                            name='first_name'
                            value={formik.values.first_name}
                            type='text'
                            placeholder='First Name'
                            label='First Name'
                            handleChange={formik.handleChange}
                            handleBlur={formik.handleBlur}
                            required
                            error={formik.errors.first_name && formik.touched.first_name ? formik.errors.first_name : null}
                        />
                        <Input
                            name='last_name'
                            value={formik.values.last_name}
                            type='text'
                            placeholder='Last Name'
                            label='Last Name'
                            handleChange={formik.handleChange}
                            handleBlur={formik.handleBlur}
                            required
                            error={formik.errors.last_name && formik.touched.last_name ? formik.errors.last_name : null}
                        />
                        <Input
                            name='email'
                            value={formik.values.email}
                            type='email'
                            placeholder='Email'
                            label='Email'
                            handleChange={formik.handleChange}
                            handleBlur={formik.handleBlur}
                            required
                            error={formik.errors.email && formik.touched.email ? formik.errors.email : null}
                        />
                        <Input
                            name='referrer'
                            value={formik.values.referrer}
                            type='text'
                            placeholder='Referral Code'
                            label='Referral Code'
                            handleChange={formik.handleChange}
                            handleBlur={formik.handleBlur}
                            disabled={!!params?.referrer}
                            error={formik.errors.referrer && formik.touched.referrer ? formik.errors.referrer : null}
                        />
                        <p className="small text-muted">
                            We'll email you a link to set your password. You can complete the rest of your profile anytime from your dashboard.
                        </p>
                        <div className="flex justify-content-end">
                            <button type="submit" className="btn btn-primary" disabled={isLoading} onClick={() => scrollToErrors(formik.errors)}>{(isLoading) && <LoadingIndicator />} Create</button>
                        </div>
                    </form>
                </div>

                <div className="card-footer">
                    Already have an account? <Link className="small" to="/signin">Signin</Link>
                </div>
            </div>
        </AuthLayout>
    );
}

export default SignupPage;
export const months = [{ value: 1, label: 'January' }, { value: 2, label: 'February' }, { value: 3, label: 'March' }, { value: 4, label: 'April' }, { value: 5, label: 'May' }, { value: 6, label: 'June' }, { value: 7, label: 'July' }, { value: 8, label: 'August' }, { value: 9, label: 'September' }, { value: 10, label: 'October' }, { value: 11, label: 'November' }, { value: 12, label: 'December' }];


const validationSchema = Yup.object({
    first_name: Yup.string()
        .matches(
            /^[a-zA-Z0-9\s .!?,"-]+$/,
            'field accepts only string, numbers and hyphens'
        )
        .required('Field cannot be empty'),
    last_name: Yup.string()
        .matches(
            /^[a-zA-Z0-9\s .!?,"-]+$/,
            'field accepts only string, numbers and hyphens'
        )
        .required('Field cannot be empty'),
    email: Yup.string()
        .email('must be valid email')
        .required('Must not be empty'),
})
